import StartupException from "../exception/StartupException";

export default class EnvConfig {
	public name: string;
	public appPath: string;
	public graphqlUri: string;
	public gatewayUri: string;
	public logoutUri: string;
	public uploadUri: string;
	public tokenRefreshUri: string;
	public keepaliveUri: string;

	public static fromObject(source: object): EnvConfig {
		// validator
		// import validator from ts-validate
		//

		if(typeof source !== "object") {
			throw new StartupException("Failed to parse env config");
		}

		return source as EnvConfig;
	}

}



// WEBPACK FOOTER //
// ./src/core/util/config/EnvConfig.ts